import { createStore } from 'vuex'

var URL = 'https://server-web.konaweselatankab.go.id/';
var URLS = 'https://brida.konaweselatankab.go.id/';

var UNIT = 'qgBTxpf6X8JhmFujb';

export default createStore({
  state: {
    UNIT_KERJA : UNIT,
    url : {
      URL : URLS,
      URL_APP : URL,
      URL_SLIDER : URL + 'api/v1/publish_balitbang_slider/',
      URL_SAMBUTAN : URL + 'api/v1/publish_balitbang_sambutan/',
      URL_BERITA : URL + 'api/v1/web_publish_berita/',
      URL_FOTO : URL + 'api/v1/publish_balitbang_foto/',
      URL_VIDEO : URL + 'api/v1/publish_balitbang_video/',
      URL_VISI : URL + 'api/v1/publish_balitbang_visi_misi/',
      URL_STRUKTUR : URL + 'api/v1/publish_balitbang_struktur_organisasi/',
      URL_TUPOKSI : URL + 'api/v1/publish_balitbang_tupoksi/',
      URL_LINK : URL + 'api/v1/web_publish_link_terkait/',
      URL_PEJABAT : URL + 'api/v1/publish_balitbang_profil_pejabat/',
      URL_BERITA : URL + 'api/v1/web_publish_berita/',
      URL_PENGUMUMAN : URL + 'api/v1/publish_balitbang_pengumuman/',
      URL_SOP : URL + 'api/v1/publish_balitbang_sop/',
      URL_KABAN : URL + 'api/v1/publish_balitbang_kepala/',
      URL_SEKRETARIAT : URL + 'api/v1/publish_balitbang_sekretariat/',
      URL_SOSIAL : URL + 'api/v1/publish_balitbang_pemerintahan/',
      URL_EKONOMI : URL + 'api/v1/publish_balitbang_pembangunan/',
      URL_INOVASI : URL + 'api/v1/publish_balitbang_teknologi/',
      URL_UPTD : URL + 'api/v1/publish_balitbang_uptd/',
      URL_FUNGSIONAL : URL + 'api/v1/publish_balitbang_fungsional/',
      URL_PERATURAN : URL + 'api/v1/publish_balitbang_dokumen/',
      URL_DOKUMEN : URL + 'api/v1/publish_balitbang_download/',
      URL_PENELITIAN : URL + 'api/v1/publish_balitbang_penelitian/',
      URL_ARTIKEL : URL + 'api/v1/publish_balitbang_artikel/',
      URL_JURNAL : URL + 'api/v1/publish_balitbang_jurnal/',
      URL_FOTO : URL + 'api/v1/publish_balitbang_foto/',
      URL_VIDEO : URL + 'api/v1/publish_balitbang_video/',
      URL_SIDA : URL + 'api/v1/publish_balitbang_inovasi/',
    }
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
